// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__CuzaM","alert":"SettungsInbox_alert__3UmNi"};